import axios from 'axios';
import { BASE_URL } from './api';

export async function getGroups(token, queryParams='') {
    return axios({
        method: 'get',
        url: `${BASE_URL}/groups/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    });

}